<template>
  <div id="app">
    <isIETemplate v-if="isIe" />
    <template v-else>
      <router-view class="app_view_default" />
    </template>
  </div>
</template>

<script>
import { isIE } from "./utils/helpers";
import isIETemplate from "./components/isIE";
export default {
  name: "App",
  components: {
    isIETemplate,
  },
  data() {
    return {
      isIe: false,
    };
  },
  created() {
    this.isIe = isIE();
  },
};
</script>
<style>
</style>
